export enum Products {
  Office = 'office',
  Coworking = 'coworking',
  MeetingRoom = 'meeting-room',
  Suite = 'suite',
  Virtual = 'virtual',
}
